import React, { useCallback } from 'react';
import DropdownMultiSelect from '../DropdownMultiSelect/DropdownMultiSelect';
import { PaymentMethodFilterTypes, getSelectedOptionsFromValues } from '../../config/FilterOptionTypes';
import { useCompany } from '../CompanySelection/CompanyContext';
import { ECHECK } from '../../config/PaymentMethods';

const ECHECK_FILTER_CMPNY_FEAT = "InsightsDisplayECheckFilter"

export default function PaymentMethodFilter(props) {
    const { companyFeaturesList } = useCompany();
    let eCheckCompanyFeature = companyFeaturesList.find((f) => f.name === ECHECK_FILTER_CMPNY_FEAT);
    const displayECheckOption = eCheckCompanyFeature ? eCheckCompanyFeature.active : false;

    //override for payment method dropdown options
    let paymentMethodOptions = props.options || PaymentMethodFilterTypes;
    if (!displayECheckOption) {
        // remove eCheck option
        paymentMethodOptions = paymentMethodOptions.filter(m => m.value !== ECHECK);
    }

    const selectedOptions = useCallback(() => {
        return props.values ? getSelectedOptionsFromValues(PaymentMethodFilterTypes, props.values) : PaymentMethodFilterTypes;
    }, [props.values]);

    return (
        <DropdownMultiSelect options={paymentMethodOptions} selectedOptions={selectedOptions} label='Payment Method' type='paymentMethod' onChange={props.onChange} isMobile={props.isMobile} />
    );
}